<template>
    <div>
        <div v-if="!hasErrors" class="row mb-3">
            <div class="col-4"></div>
            <div class="col-8 text-right">
                <year-handler
                    :start="meta.start"
                    :end="meta.end"
                    :next="meta.next"
                    :prev="meta.prev"
                />
            </div>
        </div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>

            <b-table
                responsive
                small
                :items="items"
                :fields="fields"
                :filter="filter"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="id"
                @filtered="onFiltered"
            >
                <template #cell(m1)="data">
                    <month-charge-handler :charge="data.item.m1.duration" />
                </template>
                <template #cell(m2)="data">
                    <month-charge-handler :charge="data.item.m2.duration" />
                </template>
                <template #cell(m3)="data">
                    <month-charge-handler :charge="data.item.m3.duration" />
                </template>
                <template #cell(m4)="data">
                    <month-charge-handler :charge="data.item.m4.duration" />
                </template>
                <template #cell(m5)="data">
                    <month-charge-handler :charge="data.item.m5.duration" />
                </template>
                <template #cell(m6)="data">
                    <month-charge-handler :charge="data.item.m6.duration" />
                </template>
                <template #cell(m7)="data">
                    <month-charge-handler :charge="data.item.m7.duration" />
                </template>
                <template #cell(m8)="data">
                    <month-charge-handler :charge="data.item.m8.duration" />
                </template>
                <template #cell(m9)="data">
                    <month-charge-handler :charge="data.item.m9.duration" />
                </template>
                <template #cell(m10)="data">
                    <month-charge-handler :charge="data.item.m10.duration" />
                </template>
                <template #cell(m11)="data">
                    <month-charge-handler :charge="data.item.m11.duration" />
                </template>
                <template #cell(m12)="data">
                    <month-charge-handler :charge="data.item.m12.duration" />
                </template>
                <template #cell(sum)="data">
                    <month-charge-handler :charge="data.item.sum.duration" />
                </template>

                <template slot="bottom-row">
                    <td class="td-bold">TOTAL</td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM1" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM2" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM3" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM4" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM5" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM6" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM7" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM8" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM9" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM10" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM11" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalM12" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalSum" />
                    </td>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TableHandler from '../../../common/mixins/TableHandler.vue'
import MonthChargeHandler from '../../../common/components/MonthChargeHandler.vue'
import loading from '../../../common/components/loading.vue'
import yearHandler from '../components/YearHandler.vue'

export default {
    name: 'CollaboratorsYearReport',

    components: {
        MonthChargeHandler,
        loading,
        yearHandler,
    },

    mixins: [TableHandler],

    props: {
        todayY: '',
        todayM: '',
        todayD: '',
    },

    data() {
        return {
            meta: {},
            fields: [
                {
                    key: 'name',
                    label: 'Collaborateur',
                    sortable: true,
                },
                {
                    key: 'm1',
                    label: 'jan',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm2',
                    label: 'fév',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm3',
                    label: 'mar',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm4',
                    label: 'avr',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm5',
                    label: 'mai',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm6',
                    label: 'jun',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm7',
                    label: 'jul',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm8',
                    label: 'aou',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm9',
                    label: 'sep',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm10',
                    label: 'oct',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm11',
                    label: 'nov',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm12',
                    label: 'déc',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'sum',
                    label: 'TOTAL',
                    sortable: true,
                    class: 'text-right td-bold',
                },
            ],
        }
    },
    computed: {
        ...mapState({
            accountingFirmUser: (state) =>
                state.timeSheetsVM.filters.accountingFirmUser,
            currentDate: (state) => state.timeSheetsVM.currentDate,
        }),

        totalM1() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m1.duration),
                0
            )
        },

        totalM2() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m2.duration),
                0
            )
        },

        totalM3() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m3.duration),
                0
            )
        },

        totalM4() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m4.duration),
                0.0
            )
        },

        totalM5() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m5.duration),
                0
            )
        },

        totalM6() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m6.duration),
                0
            )
        },

        totalM7() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m7.duration),
                0
            )
        },

        totalM8() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m8.duration),
                0
            )
        },

        totalM9() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m9.duration),
                0
            )
        },

        totalM10() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m10.duration),
                0.0
            )
        },

        totalM11() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m11.duration),
                0
            )
        },

        totalM12() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.m12.duration),
                0
            )
        },

        totalSum() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.sum.duration),
                0
            )
        },
    },

    async created() {
        this.$store.commit(
            'browsing/SET_PAGE_NAME',
            'accountingFirmTimeSheetYearReport'
        )
        this.$store.commit(
            'timeSheetsVM/SET_CURRENT_DATE',
            `${this.todayY}/${this.todayM}/${this.todayD}`
        )
        await this.getItems()
    },

    methods: {
        async getItems() {
            try {
                this.loading = true
                const response = await this.$axios.get(
                    `/time-sheets/reporting/accountingFirms/year/${this.currentDate}`
                )
                this.items = response.data.data
                this.meta = response.data.meta
                this.loading = false
            } catch (error) {
                // console.log(error)
                this.handleErrors(error.response)
            }
        },
    },
}
</script>

<style scoped></style>
